export const INPUTS = {
    COLLECTION_TYPE: "type",
    LABEL: "label",
    BUTTON_LABEL: "buttonLabel",
    BUTTON_URL: "buttonUrl",
    QUERY_TYPE: "queryType",
    ID_LIST: "idList",
    SEARCH_STRING: "searchString",
    STATE: "state",
    ID_MAPS: "idMaps",
    ID: "id",
    ACCORDION_ITEMS: "accordionItems",
    TITLE: "title",
    DESCRIPTION: "description",
    FORM_ID: "formId",
    SRC: "src",
    DARK_SRC: "darkSrc",
    ALT: "alt",
}

export const FRIENDLY_INPUT_NAMES = {
    COLLECTION_TYPE: "Collection type",
    FORM_ID: "Form ID",
}

export const INPUT_TYPES = {
    STRING: "string",
    LIST: "list",
}

export const DEFAULT_VALUES = {
    LABEL: "Collection",
    BUTTON_LABEL: "See more",
    STATE: "Texas",
    COLLECTION_LABEL_LISTINGS: "Listings Collection",
    COLLECTION_LABEL_OUTFITTERS: "Outfitters Collection",
    // eslint-disable-next-line no-secrets/no-secrets
    SEARCH_STRING_LISTINGS: "query=hunt&species=afnfYLAPqbXI&type=HUNTING",
    SEARCH_STRING_OUTFITTERS: "state=texas&isFeatured=true&text=ducks",
    FORM_ID: "3d20c0f7-bcf1-4dae-b996-46a916d358fb",
}

export const BUILDER_CUSTOM_COMPONENTS = {
    PRIMARY_BUTTON: "Primary Button",
    OUTFITTERS_COLLECTION: "Outfitters Collection",
    LISTINGS_COLLECTION: "Listings Collection",
    ACCORDION: "Accordion",
    PRICING_TABLE: "Pricing Table",
    HUBSPOT_FORM: "Hubspot Form",
    COLOR_MODE_IMAGE: "Color Mode Image",
    GRADIENT_BUTTON: "Gradient Button",
}

export const EDITOR_SETTINGS_KEY = "editor.settings"

// These can be anything and are used to display an image in the builder.io editor
// It helps with building in the editor
export const COMPONENT_IMAGES = {
    [BUILDER_CUSTOM_COMPONENTS.OUTFITTERS_COLLECTION]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/campground.svg",
    [BUILDER_CUSTOM_COMPONENTS.LISTINGS_COLLECTION]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/list-ul.svg",
    [BUILDER_CUSTOM_COMPONENTS.ACCORDION]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/angle-down.svg",
    [BUILDER_CUSTOM_COMPONENTS.PRICING_TABLE]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/table.svg",
    [BUILDER_CUSTOM_COMPONENTS.HUBSPOT_FORM]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/file-lines.svg",
    [BUILDER_CUSTOM_COMPONENTS.COLOR_MODE_IMAGE]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/circle-half-stroke.svg",
    [BUILDER_CUSTOM_COMPONENTS.GRADIENT_BUTTON]:
        "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/chevron-right.svg",
} as const
